(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["geolizr-amazon-poup"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("geolizr.popup.init", () => {
      Geolizr.getGeoData(data =>  {
        var popups = Geolizr.popups.popups.filter(popup => popup.id == 4270);
        var countryPopup = Geolizr.popups.popups.filter(popup => popup.countries.indexOf(data.country.code) > -1);
        if(popups.length === 1 && countryPopup.length === 0) {
          var popup = popups[0];
          let c = window.amazonData.findDataByCountry(data.country.code);
          if(typeof c === "object" && c !== null) {
            document.addEventListener('popup.show', (popup) => {
              let iframe = document.getElementById('geolizr-popup-content-iframe');
              iframe.addEventListener("load", () => {
                if(typeof iframe.contentWindow.addHtmlContent === "function") {
                  iframe.contentWindow.addHtmlContent(c);
                }
              });
            })
            Geolizr.popups.showPopup(popup);
          }
        }
      })
    });

  } catch(e) { console.error(e); }
})();
})();
